import { z, ZodError } from "zod";

export interface Parseable<T> {
    parse: (input: unknown) => T;
}

const ApplePlatform = z.enum(["ios", "osx"]);
const AndroidPlatform = z.enum(["android", "amazon"]);
const DevelopmentPlatform = z.enum(["windows"]);

const stringToLowercase = (val: unknown) => {
    if (typeof val !== "string") {
        return val;
    }

    return val.toLowerCase();
};

const Platform = z.preprocess(
    stringToLowercase,
    ApplePlatform.or(AndroidPlatform).or(DevelopmentPlatform),
);

export const GameParams = z.object({
    channel: z.string().or(z.number()).nullish(),
    country: z.string().optional(),
    jwt: z.string().nullish(),
    maintenance: z.coerce.boolean(),
    platform: Platform.optional(),
    playerTag: z.string().nullish(),
    xp: z.number().nullish(),
});

export type GameParams = z.infer<typeof GameParams>;

export function parseGameParams<T>(
    input: unknown,
    passedParser?: Parseable<T>,
): { output: T; validationError?: ZodError } {
    const parser = passedParser ?? (GameParams as unknown as Parseable<T>);
    try {
        return { output: parser.parse(input) };
    } catch (ex) {
        if (ex instanceof ZodError) {
            const maintenance = Boolean(
                (input as Record<string, unknown>).maintenance,
            );
            return {
                output: {
                    ...(input as Record<string, unknown>),
                    maintenance,
                } as T,
                validationError: ex,
            };
        }

        throw ex;
    }
}
